export const formatAge = (days: number): string =>
  days > 365 ? `${(days / 365).toFixed(1)}yr` : `${Math.round(days)}d`;

export const formatMultiple = (v: number): string => `${v.toFixed(2)}x`;

export const pct = (v: number): string => `${v.toFixed(2)}%`;

export const truncateAddress = (a: string): string =>
  a.length > 11 ? `${a.slice(0, 5)}..${a.slice(-4)}` : a;
